export const reportGroups = [
  {
    id: "food",
    label: "健康养生传闻",
  },
  {
    id: "finance",
    label: "财经消费传闻",
  },
  {
    id: "tech",
    label: "数码科技传闻",
  },
  {
    id: "society",
    label: "社会民生传闻",
  },
];

export type ReportItem = {
  group: string;
  title: string;
  summary: string;
  conclusion: "属实" | "部分属实" | "存疑" | "不实";
  confidence: number;
  date: string;
  evidence: number;
  sources: number;
};

export const reports: ReportItem[] = [
  {
    group: "健康养生传闻",
    title: "「隔夜菜亚硝酸盐超标会致癌」说法是否靠谱",
    summary:
      "核查发现该说法夸大了风险。亚硝酸盐含量确实会随时间上升，但在常规冷藏条件下多数菜品仍在安全范围，需分品类判断。",
    conclusion: "部分属实",
    confidence: 74,
    date: "2026-09-02",
    evidence: 8,
    sources: 4,
  },
  {
    group: "财经消费传闻",
    title: "「某支付平台每笔交易偷偷多扣手续费」传言的真相",
    summary:
      "经调取账单明细与平台规则逐笔比对，未发现额外扣费记录，传闻中的截图系旧版界面与第三方渠道费用混淆所致。",
    conclusion: "不实",
    confidence: 92,
    date: "2026-08-28",
    evidence: 12,
    sources: 5,
  },
  {
    group: "数码科技传闻",
    title: "「充电整晚会损伤手机电池」还需要担心吗",
    summary:
      "现代设备的充电管理与电池保护芯片已能自动断电，整晚充电对健康电池的损耗可忽略，结论已获厂商技术支持说明佐证。",
    conclusion: "不实",
    confidence: 88,
    date: "2026-08-21",
    evidence: 9,
    sources: 3,
  },
  {
    group: "社会民生传闻",
    title: "「某连锁门店大幅裁员的聊天记录」是否属实",
    summary:
      "所传聊天记录无时间戳与上下文，涉事企业已公开回应经营正常，尚未见权威监管或仲裁信息佐证裁员规模。",
    conclusion: "存疑",
    confidence: 52,
    date: "2026-08-16",
    evidence: 5,
    sources: 2,
  },
  {
    group: "健康养生传闻",
    title: "「醋泡食物能软化血管」流传多年仍被相信",
    summary:
      "醋经消化进入血液后浓度极低，达不到软化血管效果，医学共识未见支持性证据，相关说法属于以偏概全。",
    conclusion: "不实",
    confidence: 85,
    date: "2026-08-09",
    evidence: 7,
    sources: 4,
  },
  {
    group: "财经消费传闻",
    title: "「某品牌成分表更新疑似悄悄减量」争议的核对结果",
    summary:
      "对比该批次与历史备案配方，关键成分比例一致，差异来自宣传口径与含量标注方式，属包装表述问题而非实质减量。",
    conclusion: "部分属实",
    confidence: 67,
    date: "2026-08-03",
    evidence: 11,
    sources: 3,
  },
];

export const conclusionMeta: Record<
  string,
  { key: string; cls: string; chip: string }
> = {
  属实: {
    key: "real",
    cls: "bg-primary-500 text-background-50",
    chip: "text-primary-700 bg-primary-100 border-primary-200",
  },
  部分属实: {
    key: "partial",
    cls: "bg-accent-500 text-background-50",
    chip: "text-accent-700 bg-accent-100 border-accent-300",
  },
  存疑: {
    key: "doubt",
    cls: "bg-secondary-500 text-background-50",
    chip: "text-secondary-700 bg-secondary-100 border-secondary-200",
  },
  不实: {
    key: "false",
    cls: "bg-foreground-900 text-background-50",
    chip: "text-foreground-700 bg-foreground-100 border-foreground-200",
  },
};